<script lang="ts" setup>
import { ref, Ref } from 'vue'
import { useDialogPluginComponent, Notify } from 'quasar'
import { useApi } from '@/store/useAppStore'
import UserApi from '@/services/api/core/UserApi'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseDialog from '@/components/base/BaseDialog.vue'

interface Props {
  node: any
}
const props = withDefaults(defineProps<Props>(), {})

const emit = defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const userApi: UserApi = useApi()
const newDocumentName: Ref<string> = ref(props.node.name)
const isLoading: Ref<boolean> = ref(false)

async function renameFile() {
  emit('ok', newDocumentName.value)
}
</script>
<template>
  <q-dialog ref="dialogRef">
    <BaseDialog title="Renommer la marque blanche" :is-dialog-loading="isLoading" @on-dialog-cancel="onDialogCancel()"
      @hide="onDialogHide()">
      <template #body>
        <BaseInput v-model="newDocumentName" type="text" label="Nom" autofocus autoselect @keyup.enter="renameFile()">
        </BaseInput>
      </template>
      <template #actions>
        <q-btn flat label="Renommer" @click="renameFile()" color="primary" :disable="newDocumentName === ''" />
      </template>
    </BaseDialog>
  </q-dialog>
</template>
<style lang="scss" scoped></style>
